module.exports = __webpack_public_path__ + "img/fig29.12268e52.jpg";